import {EntitySocialResponse} from '../../../../../../../backend/interfaces/entity-social-response';

export function userSocialResponseMainColor(
  userSocialResponses: string[] | undefined,
  entitySocialResponses: EntitySocialResponse[]
): string | undefined {
  return entitySocialResponses.find((x) => x.id === userSocialResponses?.[0])?.foregroundColor;
}
